import { getUrlExtension } from './helpers';

export default function imageLoader({ src, width }) {
  const imageFormat = getUrlExtension(src);

  return `${src}?auto=format&fm=${imageFormat}&fit=max&w=${width}`;
}
